import ChatButton from "@components/inputs/ChatButton";
import LanguageSelect from "@components/inputs/LanguageSelect";
import { cn, PropsWithClassName } from "kz-ui-sdk";

interface OnboardingBottomBarProps extends PropsWithClassName {
  showChatButton?: boolean;
  showLanguageSelect?: boolean;
  style?: React.CSSProperties;
}

const OnboardingBottomBar = ({
  showChatButton = true,
  showLanguageSelect = true,
  className,
  style,
}: OnboardingBottomBarProps) => {
  if (!showChatButton && !showLanguageSelect) return null;

  return (
    <div
      className={cn("my-4 flex w-full items-center justify-between", className)}
      style={style}
    >
      {showLanguageSelect && <LanguageSelect className="me-auto" />}
      {showChatButton && <ChatButton className="ms-auto" />}
    </div>
  );
};

export default OnboardingBottomBar;
